export const MAX_DRAFT_IMAGES_COUNT = 16;
export const ETSY_MAX_DRAFT_IMAGES_COUNT = 16;
export const EBAY_MAX_DRAFT_IMAGES_COUNT = 16;
export const MERCARI_MAX_DRAFT_IMAGES_COUNT = 16;
